<template>
	<div class="page">
		<div class="container">
			<Row>
				<Col flex="1 1 350px">
				<div class="left">
					<div class="info-warp">
						<img width="350px" style="margin: 50px 0 80px 0;" src="../assets/gywm-1.png" alt="">
						<div class="tip">
							<div class="des">GET IN TOUCH</div>
							<div class="title">联系咨询</div>
						</div>
						<div class="info">
							<div class="title">感谢联系INCO</div>
							<div class="text">请您填写一下信息，以便获取相关资料，谢谢</div>
							<Form ref="formInline" :model="formTop" class="form" label-position="top"
								:rules="ruleInline">
								<FormItem label="手机号码" prop="phone">
									<Input class="bgStyle" v-model="formTop.phone" placeholder="请您填写手机号码"></Input>
								</FormItem>
								<FormItem label="电子邮箱" prop='email'>
									<Input class="bgStyle" v-model="formTop.email" placeholder="请您填写电子邮箱"></Input>
								</FormItem>
								<FormItem label="院校名称" prop='school'>
									<Input class="bgStyle" v-model="formTop.school" placeholder="请您填写院校名称"></Input>
								</FormItem>
								<FormItem label="部门职务">
									<Input class="bgStyle" v-model="formTop.position" placeholder="请您填写部门职务"></Input>
								</FormItem>
								<FormItem label="您的姓名">
									<Input class="bgStyle" v-model="formTop.name" placeholder="请您填写您的姓名"></Input>
								</FormItem>
								<FormItem label="您是否需要INCO的技术顾问咨询">
									<RadioGroup v-model="formTop.technical">
										<Radio label="1" style="color: #fff">是</Radio>
										<Radio label="0" style="color: #fff">否</Radio>
									</RadioGroup>
								</FormItem>
								<FormItem>
									<div style="text-align: center;">
										<div class="btn" @click="handleSubmit('formInline')">提交信息</div>
									</div>
								</FormItem>
							</Form>
						</div>
						<div class="gap"></div>
						<p class="text">FOLLOW US</p>
						<p class="text">关注我们</p>
						<div class="wechat"></div>
					</div>
				</div>
				</Col>
				<Col flex="0 1 850px">
				<div class="right">
					<img class="dtImg" width="100%" src="../assets/lxwmimg.jpg" alt="">
					<!-- <div class="bottom">
		      <p class="title">北京赢科天地电子有限公司<br>BEIJING INCON ELECTPONIC CO.,LTD</p>
		      <div class="grid">
		        <div class="left-wrap">
		          <div class="company" style="width: 260px;">
		            <p>北京总公司</p>
					<div><p style="display: inline-block;width: 30px;height: 30px;vertical-align: top;">地址:</p><p style="display: inline-block;width: 220px;">北京市海淀区花园东路1号牡丹宾馆办公区4号楼5层501</p></div>
		            <p>电话:010-82887279 82886006</p>
		            <p>传真:010-82887279-801</p>
		            <p>电子邮箱:incon@incons.com..cn</p>
		          </div>
		        </div>
		        <div class="right-wrap">
		          <div class="company" v-for="(item,index) in list" :key="index">
		            <p>{{item.title}}</p>
					<div><p style="display: inline-block;width: 30px;vertical-align: top;">地址:</p><p style="display: inline-block;width: 228px;"> {{item.address}}</p></div>
		            <p>电话: {{item.phone}}</p>
		            <p>传真: {{item.cz}}</p>
		            <p>电子邮箱: incon@incons.com..cn</p>
		          </div>
		        </div>
		      </div>
		    </div> -->
				</div>
				</Col>
			</Row>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'HelloWorld',
		data() {
			return {
				list: [{
						title: '哈尔滨分公司',
						address: '哈尔滨市道里区丽江路3926号银泰城写字楼F座1301室',
						phone: '0451-87915641  15104515628',
						cz: '010-82887279-801',
						email: 'incon@incons.com..cn',
					},
					{
						title: '成都分公司',
						address: '成都市武侯区锦绣路33号棕北国际2栋3单元20层1号',
						phone: '010-82887279  18600648843',
						cz: '010-82887279-801',
						email: 'incon@incons.com..cn',
					},
					{
						title: '青岛分公司',
						address: '青岛市市南区香港西路43号国家发改委青岛疗养院2号楼302',
						phone: '010-82887279  17663901357',
						cz: '010-82887279-801',
						email: 'incon@incons.com..cn',
					},
					{
						title: '南京分公司',
						address: '南京市秦淮区标营4号信息软件大厦1901室',
						phone: '010-82887279  18001581469',
						cz: '010-82887279-801',
						email: 'incon@incons.com..cn',
					},
					{
						title: '深圳分公司',
						address: '广东省深圳市南山区桃源街道云谷2期6栋415室',
						phone: '010-82887279  13600427241',
						cz: '010-82887279-801',
						email: 'incon@incons.com..cn',
					},
					{
						title: '济宁分公司',
						address: '山东省济宁市任城区永基城a座1913',
						phone: '010-82887279  15311931013',
						cz: '010-82887279-801',
						email: 'incon@incons.com..cn',
					},
					{
						title: '烟台分公司',
						address: '山东省烟台市芝罘(fu)区黄务街道通世南路5号1861文化创意产业园C2-813室',
						phone: '010-82887279  13791157979',
						cz: '010-82887279-801',
						email: 'incon@incons.com..cn',
					},
				],
				formTop: {
					phone: '',
					email: '',
					school: '',
					position: '',
					name: '',
					technical: '1',
				},
				ruleInline: {
					phone: [{
							required: true,
							message: "请输入手机号码",
							trigger: "blur"
						},
						{
							pattern: /^1[3456789]\d{9}$/,
							message: "手机号码格式不正确",
							trigger: "blur"
						}
					],
					email: [{
							required: true,
							message: '请输入邮箱',
							trigger: 'blur'
						},
						{
							type: 'email',
							message: '邮箱格式不正确',
							trigger: 'blur'
						}
					],
					school: [{
							required: true,
							message: '请输入院校名称',
							trigger: 'blur'
						}
					],
				}
			}
		},
		mounted() {
			this.$Message.config({
				top: 200,
				duration: 2
			})
		},
		destroyed() {
			this.$Message.destroy()
		},
		methods: {
			getStyles(index) {
				return {
					color: index == 3 ? 'black' : 'black'
				}
			},
			handleSubmit(name) {
				this.$refs[name].validate((valid) => {
					if (valid) {
						this.$Message.success('提交成功!');
						setTimeout(() => {
							this.formTop.phone='';
							this.formTop.email='';
							this.formTop.school='';
							this.formTop.position='';
							this.formTop.name='';
							this.formTop.techincal='1';
						}, 500);
					}
				})
			}
		},
	}
</script>

<style scoped lang="less">
	.page {
		background-image: url('../assets/bg-3.jpg');
		background-repeat: no-repeat;
		background-size: 50% 100%;

		.container {
			width: 1250px;
			max-width: 1250px;
			margin: 0 auto;
		}

		.left {
			display: flex;
			justify-content: flex-end;
			// align-items: center;
			height: 100%;
			background-color: #fff;
			background-image: url('../assets/bg-3.jpg');
			background-repeat: no-repeat;
			background-size: cover;

			.info-warp {
				width: 350px;
				margin-right: 30px;

				.tip {
					.des {
						color: #999;
						font-size: 14px;
					}

					.title {
						line-height: 50px;
						font-size: 26px;
						font-weight: 700;
					}
				}

				.info {
					padding: 20px;
					background-image: url('../assets/gywm-8.jpg');
					background-repeat: no-repeat;
					background-size: cover;

					.title {
						font-size: 20px;
						font-weight: 600;
						color: rgb(222, 242, 213);
					}

					.text {
						margin-bottom: 20px;
						font-size: 14px;
						line-height: 30px;
						color: #fff;
						border-bottom: 1px solid #fff;
					}

					.btn {
						display: inline-block;
						width: 200px;
						padding: 0 20px;
						font-size: 14px;
						background: rgba(222, 242, 213, 0.7);
						color: #fff;
						cursor: pointer;
					}
				}

				.gap {
					width: 100%;
					height: 1px;
					background: #000;
					margin: 50px 0 20px 0;
				}

				.text {
					line-height: 18px;
					font-size: 14px;
					font-weight: 500;
				}

				.wechat {
					width: 20%;
					padding: 30% 30%;
					margin: 30px auto;
					background-image: url('../assets/gzh.jpg');
					background-repeat: no-repeat;
					background-size: cover;
				}
			}
		}

		.right {
			background-color: #fff;
			padding: 0 20px;

			.dtImg {
				padding: 30px 0;
				padding-top: 180px;
			}

			.bottom {
				.title {
					margin-bottom: 20px;
					font-size: 14px;
					font-weight: 700;
				}

				.grid {
					display: flex;
					align-content: flex-start;

					.right-wrap {
						flex: 1;
					}

					.company {
						display: inline-block;
						vertical-align: top;
						font-size: 12px;
						padding-right: 10px;
						padding-bottom: 20px;
					}
				}
			}
		}
	}

	.form /deep/ .ivu-form-item-label {
		font-size: 14px;
		font-weight: 500;
		color: #fff;
	}

	.bgStyle /deep/ .ivu-input {
		border: none;
		border-radius: 0;
		background: rgba(222, 242, 213, 0.7);
		color: #fff;
	}
</style>
